// Utility to test keep-alive service manually
import keepAliveService from '../services/keepAlive';

// Test the keep-alive service
export const testKeepAlive = () => {
  console.log('Testing keep-alive service...');
  console.log('Current status:', keepAliveService.getStatus());
  
  // Test a single ping
  keepAliveService.pingServer();
};

// Start keep-alive service manually (for testing)
export const startKeepAlive = () => {
  console.log('Starting keep-alive service manually...');
  keepAliveService.start();
};

// Stop keep-alive service manually (for testing)
export const stopKeepAlive = () => {
  console.log('Stopping keep-alive service manually...');
  keepAliveService.stop();
};

// Get keep-alive status
export const getKeepAliveStatus = () => {
  return keepAliveService.getStatus();
};

// Make functions available globally for testing in console
if (typeof window !== 'undefined') {
  window.testKeepAlive = testKeepAlive;
  window.startKeepAlive = startKeepAlive;
  window.stopKeepAlive = stopKeepAlive;
  window.getKeepAliveStatus = getKeepAliveStatus;
}
